import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    setTimeout(function () {
      document.body.scrollTo(0, 0);
    }, 200);
  }, [pathname]);
};

export default useScrollTop;
